export const MAIN_URL = "https://installerv2.boxbyld.tech/api/";
